import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import NafathModalContent from './NafathModalContent';

interface NafathModalProps {
  open: boolean;
  onClose: () => void;
  currentStep: NafathStep;
  onContinue: () => void;
  loading: boolean;
  attemptsLeft?: number;
  nafathCooldown?: string;
  nafathCode?: number;
  retryCooldown?: string;
  setIsEnabled?: any;
}

export type NafathStep =
  | 'CONFIRMATION'
  | 'NAFATH_NUMBER'
  | 'REJECTED'
  | 'TEMPORARILY_LOCKED'
  | 'SESSION_EXPIRED'
  | 'PERMANENTLY_LOCKED'
  | 'SOMETHING_WRONG';

const NafathModal: FC<NafathModalProps> = ({
  open,
  onClose,
  currentStep,
  attemptsLeft,
  nafathCooldown,
  retryCooldown,
  nafathCode,
  onContinue,
  loading,
  setIsEnabled,
}) => {
  const { t } = useTranslation('ksaContract');
  return (
    <NafathModalContent
      setIsEnabled={setIsEnabled}
      currentStep={currentStep}
      nafathCode={nafathCode}
      nafathCooldown={nafathCooldown}
      retryCooldown={retryCooldown}
      attemptsLeft={attemptsLeft}
      onContinue={onContinue}
      loading={loading}
    />
  );
};

export default NafathModal;
